// 全画面 / 矩形描画用の単位クアッド (0,0)-(1,1)。頂点シェーダ側で変換する。

export class Quad {
  private vao: WebGLVertexArrayObject
  private vbo: WebGLBuffer

  constructor(private gl: WebGL2RenderingContext) {
    const vao = gl.createVertexArray()
    const vbo = gl.createBuffer()
    if (!vao || !vbo) throw new Error('VAO/VBO の生成に失敗')
    this.vao = vao
    this.vbo = vbo
    gl.bindVertexArray(vao)
    gl.bindBuffer(gl.ARRAY_BUFFER, vbo)
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([0, 0, 1, 0, 0, 1, 1, 1]), gl.STATIC_DRAW)
    gl.enableVertexAttribArray(0)
    gl.vertexAttribPointer(0, 2, gl.FLOAT, false, 0, 0)
    gl.bindVertexArray(null)
  }

  draw(): void {
    const gl = this.gl
    gl.bindVertexArray(this.vao)
    gl.drawArrays(gl.TRIANGLE_STRIP, 0, 4)
    gl.bindVertexArray(null)
  }

  dispose(): void {
    this.gl.deleteVertexArray(this.vao)
    this.gl.deleteBuffer(this.vbo)
  }
}
